import { BrowserInfo } from "types";

export class OrderCheckoutData {
    private totalPrice: number;
    private storeId: number;
    private logisticsId: number;
    private totalQuantity: number;
    private currency: string;
    private orderItems: OrderItemCheckoutData[];
    private shippingAddress: ShippingAddressData;
    private browserInfo: BrowserInfo;
    private shippingMethod: string;

    constructor(
        totalPrice: number,
        storeId: number,
        logisticsId: number,
        totalQuantity: number,
        currency: string,
        shippingMethod: string,
        orderItems: OrderItemCheckoutData[],
        shippingAddress: ShippingAddressData,
        browserInfo: BrowserInfo
    ) {
        this.totalPrice = totalPrice;
        this.storeId = storeId;
        this.logisticsId = logisticsId;
        this.totalQuantity = totalQuantity;
        this.currency = currency;
        this.shippingMethod = shippingMethod;
        this.orderItems = orderItems;
        this.shippingAddress = shippingAddress;
        this.browserInfo = browserInfo;
    }
}

export class OrderItemCheckoutData {

    private productId: number;
    private discountedPrice: number;
    private currency: string;
    private discountOff: string;
    private quantity: number;
    private basePrice: number;
    private applyDiscount: boolean;
    private totalPrice: number;

    constructor(
        productId: number, 
        discountedPrice: number,
        currency: string,
        discountOff: string,
        quantity: number,
        basePrice: number,
        applyDiscount: boolean,
        totalPrice: number
    ) {
        this.productId = productId;
        this.discountedPrice = discountedPrice;
        this.currency = currency;
        this.discountOff = discountOff;
        this.quantity = quantity;
        this.basePrice = basePrice;
        this.applyDiscount = applyDiscount;
        this.totalPrice = totalPrice;
    }
}

export class ShippingAddressData {
    
    private id?: number;
    private firstName: string;
    private lastName: string;
    private address: string;
    private country: string;
    private state: string;
    private email: string;
    private phone: string;
    private heading?: string;
    private defaults?: boolean;

    constructor(
        id: number,
        firstName: string,
        lastName: string,
        address: string,
        country: string,
        state: string,
        email: string,
        phone: string,
        heading: string,
        defaults: boolean
    ) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.address = address;
        this.country = country;
        this.state = state;
        this.email = email;
        this.phone = phone;
        this.heading = heading;
        this.defaults = defaults;
    }
}